import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme

const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, false] }],
  ['bold', 'italic', 'strike'],
  ['blockquote'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: ['', 'center'] }],
  [{ script: 'sub' }, { script: 'super' }],
  ['clean'],
  ['link', 'video']
]
Vue.use(VueQuillEditor, {
  modules: {
    toolbar: toolbarOptions
  }
})
